import Vue from 'vue'

import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PEBackgroundOverviewCardActions = {
  initPeBackgroundOverviewCard: ({ commit }) => {
    commit('setPeBackgroundOverviewCardLock', true)
  },
  PeBackgroundOverviewCardUpdate: async ({ commit }, { id, section }) => {
    return axiosRequest.
      patch(`/parties/${id}`, {
        num_entries: section.num_entries,
        date_first_entry: section.date_first_entry,
        date_first_entry_uncertain: section.date_first_entry_uncertain,
        departed_since_first_entry: section.departed_since_first_entry,
        confirm_departed_since_first_entry: section.confirm_departed_since_first_entry,
        date_last_entry: section.date_last_entry,
        date_last_entry_uncertain: section.date_last_entry_uncertain,
        any_enforcement_history: section.any_enforcement_history,
        any_benefits_history: section.any_benefits_history,
      }).
      then(({ data }) => {
        const updatedParty = data.party

        commit('setPeBackgroundOverviewCardLock', true)
        commit('pePatchParty', {
          num_entries: updatedParty.num_entries,
          date_first_entry: updatedParty.date_first_entry,
          date_first_entry_uncertain: updatedParty.date_first_entry_uncertain,
          departed_since_first_entry: updatedParty.departed_since_first_entry,
          confirm_departed_since_first_entry: updatedParty.confirm_departed_since_first_entry,
          date_last_entry: updatedParty.date_last_entry,
          date_last_entry_uncertain: updatedParty.date_last_entry_uncertain,
          any_enforcement_history: updatedParty.any_enforcement_history,
          any_benefits_history: updatedParty.any_benefits_history,
        })
      }).
      catch(handleError)
  },
}

export const PEBackgroundOverviewCardMutations = {
  setPeBackgroundOverviewCardLock: (state, lock) => {
    Vue.set(state.partyEdit.partySections, 'BackgroundOverviewCard', lock)
  },
}

export const PEBackgroundOverviewCardGetters = {
  PeBackgroundOverviewCardLock: state => state.partyEdit.partySections.BackgroundOverviewCard,
}
